<!--时间对标-->
<template>
	<div class="timeBenchmarkBody">
		<!--日期弹窗-->
		<datePicker ref="bgPicker" :initDate='date1' @selectDate="date1=$event,$refs.bgPicker.hide()" @selectMonth="date1=$event,$refs.bgPicker.hide()" @selectYear="date1=$event,$refs.bgPicker.hide()" :type="datePickerType"></datePicker>
		<datePicker ref="endPicker" :initDate='date2' @selectDate="cacheStore.commit('setNowSelectDate',$event),$refs.endPicker.hide()" @selectMonth="cacheStore.commit('setNowSelectDate',$event),$refs.endPicker.hide()" @selectYear="cacheStore.commit('setNowSelectDate',$event),$refs.endPicker.hide()" :type="datePickerType"></datePicker>
		<elRadioTree slot="tree" :dataList='virtualDeviceList'></elRadioTree>
		<div class="pageBody" slot="body">
			<div class="buttonLine">
				<!-- <multipleSelection title="应用类型组" nameKey="name" :list='apptypeGroups' @checkDataList="nowApptypeGroups = $event" :autoCheckIdList="nowSelectAppTypeGroupIds" @checkIdList="$store.cacheStore.commit('setNowSelectAppTypeGroupIds',$event)"></multipleSelection> -->
				<label>应用类型组：</label>
				<el-select v-model="apptypeValue" multiple collapse-tags placeholder="请选择" size='small'>
					<el-option label='全选' value='全选' @click.native='selectAll'></el-option>
					<el-option v-for="item in apptypeGroups" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
				<timeTypeSelection @selectTimetype="nowTimetype = $event"></timeTypeSelection>
				<!--日期-->
				<span class="timeTips">时间一：</span>
				<el-date-picker v-model="firstTime" value-format="timestamp" type="date" size="small" placeholder="选择日期"></el-date-picker>
				<span class="timeTips">时间二：</span>
				<el-date-picker v-model="secondTime" value-format="timestamp" type="date" size="small" placeholder="选择日期"></el-date-picker>
				<iconButton icoName="wedoButton/search.png" buttonText="查询" @buttonClick="search"></iconButton>
			</div>
			<!--图表-->
			<vchart style="height: calc(65% - .37rem);background-color: white;" ref='vchart'></vchart>
			<!--表格显示数据-->
			<el-table :data="tableList" :header-cell-style="{'text-align':'center','background': '#F1F4F7'}" :cell-style="{'text-align':'center'}" max-height="250" border>
				<el-table-column fixed type="index">
				</el-table-column>
				<el-table-column fixed prop="0" label="变量名" width="180">
				</el-table-column>
				<el-table-column v-for='(item,index) in columns' :prop="item.key" :label="item.name">
				</el-table-column>
			</el-table>
			<div style="background-color: white;display: flex;justify-content: flex-end;height:10%;">
				<el-pagination background layout="prev, pager, next" :total="mergeDataList.length" :page-size='pageLen' @current-change='clickChange' @prev-click="prevClick" @next-click="nextClick" style='margin-top: 10px;'>
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import datePicker from '@/components/module/universal/datePicker.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import multipleSelection from '@/components/module/selection/multipleSelection.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	import timeTypeSelection from '@/components/module/selection/timeTypeSelection.vue'
	import elRadioTree from '@/components/module/tree/elRadioTree.vue'
	export default {
		components: {
			treeBody,
			datePicker,
			iconButton,
			multipleSelection,
			vchart,
			timeTypeSelection,
			elRadioTree,
		},
		props: [],
		data() {
			return {
				date1: undefined,
				nowApptypeGroups: [],
				nowTimetype: 'day',
				options: {},
				dataList: [], //临时存储查询到的数据
				nowIndex: 0,
				pageLen: 20,
				weekList: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
				from2name: {},
				apptypeValue: [],
				firstTime: new Date().getTime() - 24 * 60 * 60 * 1000,
				secondTime: new Date().getTime()
			}
		},
		created() {
			//默认从昨天开始查
			this.date1 = new Date(this.date2.getTime() - 24 * 60 * 60 * 1000)
		},
		mounted() {
			debugPage = this
			//初始化图表
			this.options = this.$refs.vchart.getDefaultOptions()
			this.options.tooltip.formatter = (params, ticket, callback) => {
					var h = params[0].data[0]
					var label = ''
					params.forEach(item => {
						var values;
						if(isnull(item.data[1])) {
							values = "无采集数据";
						} else {
							values = cutDigital(item.data[1]);
						}
						label += item.seriesName + " : " + values + "</br>"
					})
					return label;
				},
				this.options.xAxis = {
					type: 'category',
					splitLine: {
						show: false,
						lineStyle: {
							width: .5,
							type: 'solid'
						}
					},
				},
				this.options.yAxis = {
					lineStyle: {
						show: false,
						width: 1,
						type: 'solid',
					}
				}
			this.options.toolbox['iconStyle'] = {
				'color': 'white',
				'borderColor': 'white',
				'shadowColor': 'white'
			}
			this.$refs.vchart.setData(this.options, true)
			this.search()
			this.apptypeValue = this.nowSelectAppTypeGroupIds
		},
		destroyed() {},
		computed: {
			nowSelectAppTypeGroupIds() {
				return this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(this.apptypeGroups)
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			cacheStore() {
				return this.$store.cacheStore
			},
			virtualDeviceList() {
				var data = this.$store.deviceStore.getters.getReadDeviceTree
				return isempty(data) ? [] : [deviceList(data)]
			},
			datePickerType() {
				switch(this.nowTimetype) {
					case 'day':
					case 'week':
						return 'day'
					case 'month':
					case 'quarter':
						return 'month'
					case 'year':
						return 'year'
				}
			},
			apptypeGroups() {
				//所有已选中的设备所具有的变量类型组
				var list = []
				var apptypeGroupIds = []
				this.variableTree.forEach(apptypeGroup => {
					if(!apptypeGroupIds.includes(apptypeGroup.id)) {
						apptypeGroupIds.push(apptypeGroup.id)
						list.push(apptypeGroup)
					}
				})
				//排序
				return list.sort((a, b) => {
					return a.serialnum - b.serialnum
				})
			},
			date2() {
				return this.cacheStore.getters.getNowSelectDate
			},
			variableTree() {
				if(this.nowVirtualDevice == undefined) {
					return []
				}
				return this.$store.variableStore.getters.getVariableTree(this.nowVirtualDevice.no)
			},
			columns() {
				/*{
					name: '变量名'
				}*/
				var list = []
				switch(this.nowTimetype) {
					case 'day':
						//取出每个整点值
						for(var i = 0; i < 24; i++) {
							list.push({
								name: (i < 10 ? '0' : '') + i + ":00",
								key: String(i + 1)
							})
						}
						break
					case 'week':
						for(var i = 0; i < 7; i++) {
							list.push({
								name: this.weekList[i],
								key: String(i + 1)
							})
						}
						break
					case 'month':
						for(var i = 1; i <= 31; i++) {
							list.push({
								name: i + "日",
								key: String(i + 1)
							})
						}
						break
					case 'quarter':
						for(var i = 0; i < 3; i++) {
							list.push({
								name: this.mergeQuarterList[i],
								key: String(i + 1)
							})
						}
						break
					case 'year':
						for(var i = 1; i <= 12; i++) {
							list.push({
								name: i + "月",
								key: String(i + 1)
							})
						}
						break
				}
				return list
			},
			nowVariableNames() {
				//当前应该显示的变量fromname列表
				var ag = this.nowApptypeGroups.map(item => {
					return item.id
				})
				var v1 = this.variableTree.filter(item => {
					return ag.includes(item.id)
				})
				if(isempty(v1)) {
					return []
				}
				var v2 = []
				v1.forEach(item => {
					item.next.forEach(i => {

						v2.push(i.fromName) //name != fromName
					})
				})
				return v2
			},
			allVariableName() {
				//所有的通讯变量名称
				var list = []
				for(var i = 0, len = this.variableTree.length; i < len; i++) {
					var next = this.variableTree[i].next
					for(var i2 = 0, len2 = next.length; i2 < len2; i2++) {
						var item = next[i2]
						this.from2name[item.fromName] = item.name
						list.push(item.fromName) //fromName
					}
				}
				return list
			},
			fiflterDataList() {
				//经过过滤的应该显示的数据列表,未合并的
				if(this.dataList.length != 2) {
					return []
				}
				if(isempty(this.dataList[0]) || isempty(this.dataList[1])) {
					return []
				}
				var list = [{}, {}]
				this.nowVariableNames.forEach(item => {
					list[0][item] = this.dataList[0][item]
					list[1][item] = this.dataList[1][item]
				})
				return list
			},
			mergeDataList() {
				//用于渲染的合并后的数组
				if(isempty(this.fiflterDataList) || this.fiflterDataList.length != 2) {
					return []
				}
				//合并后的数据列，一个方便解析的数组
				var list1 = this.tranList(this.fiflterDataList[0])
				var list2 = this.tranList(this.fiflterDataList[1])
				//两个数组交叉合并,并且加上序号
				var list = []
				for(var i = 0; i < list1.length; i++) {
					//list1[i][0] = list1[i][0] + "-" + this.date1.formatByDate()
					list1[i][0] = list1[i][0] + "-" + new Date(this.firstTime).formatByDate()
					list.push(list1[i])
					list2[i][0] = list2[i][0] + "-" + new Date(this.secondTime).formatByDate()
					//list2[i][0] = list2[i][0] + "-" + this.date2.formatByDate()
					list.push(list2[i])
				}
				return list
			},
			chartDataList() {
				//图表使用的数据
				var list = []
				for(var i = 0, len = this.mergeDataList.length; i < len; i++) {
					var l = this.mergeDataList[i]
					var l2 = [l[0]]
					switch(this.nowTimetype) {
						case 'day':
							//取出每个整点值
							for(var i2 = 1, len2 = 25; i2 < len2; i2++) { //l.length
								var value = l[i2]
								if(isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
									value = undefined
								}
								l2.push([i2 - 1, value])
							}
							break
						case 'week':
							for(var i2 = 1, len2 = 8; i2 < len2; i2++) { //l.length
								var value = l[i2]
								if(isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
									value = undefined
								}
								l2.push([this.weekList[i2 - 1], value])
							}
							break
						case 'month':
							for(var i2 = 1, len2 = 32; i2 < len2; i2++) { //l.length
								var value = l[i2]
								if(isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
									value = undefined
								}
								l2.push([(i2) + '日', value])
							}
							break
						case 'quarter':
							for(var i2 = 1, len2 = 4; i2 < len2; i2++) { //l.length
								var value = l[i2]
								if(isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
									value = undefined
								}
								l2.push([this.mergeQuarterList[i2 - 1], value])
							}
							break
						case 'year':
							for(var i2 = 1, len2 = 13; i2 < len2; i2++) { //l.length
								var value = l[i2]
								if(isNaN(parseFloat(value)) || isnull(parseFloat(value))) {
									value = undefined
								}
								l2.push([(i2) + '月', value])
							}
							break
					}

					list.push(l2)
				}
				return list
			},
			nowPage() {
				return this.mergeDataList.filter((item, index) => {
					return index >= this.nowIndex * this.pageLen && index < (this.nowIndex + 1) * this.pageLen
				})
			},
			tableList() {
				let list = this.mergeDataList.filter((item, index) => {
					return index >= this.nowIndex * this.pageLen && index < (this.nowIndex + 1) * this.pageLen
				})
				let list2 = []
				if(!isempty(list)) {
					list.forEach(item => {
						let obj = {}
						item.forEach((item2, index) => {
							obj[index] = item2
						})
						list2.push(obj)
					})
				}
				return list2
			},
			getDateText() {
				return date => {
					switch(this.nowTimetype) {
						case 'day':
							return date.formatByDate('-')
						case 'week':
							return date.formatByDate('-')
						case 'month':
							return date.formatByMonth('-')
						case 'quarter':
							return date.formatByMonth('-')
						case 'year':
							return date.getFullYear() + ''
					}
				}
			},
			mergeQuarterList() {
				//混合坐标轴
				/* if((this.date1.getMonth() / 3 | 0) == (this.date2.getMonth() / 3 | 0)) {
					//同一个季度
					return this.getQuarterList(this.date1)
				} else {
					var list1 = this.getQuarterList(this.date1)
					var list2 = this.getQuarterList(this.date2) */
				if((new Date(this.firstTime).getMonth() / 3 | 0) == (this.date2.getMonth() / 3 | 0)) {
					//同一个季度
					return this.getQuarterList(new Date(this.firstTime))
				} else {
					var list1 = this.getQuarterList(new Date(this.firstTime))
					var list2 = this.getQuarterList(new Date(this.secondTime))	
					var list = []
					for(var i = 0; i < 3; i++) {
						list.push(list1[i] + "/" + list2[i])
					}
					return list
				}
			},
			nowVirtualDevice() {
				return this.$store.deviceStore.state.nowVirtualDevice
			}
		},
		watch: {
			allVariableName(nv, ov) {
				this.search()
			},
			chartDataList(nv, ov) {
				//重新渲染
				this.reloadChart(nv)
			},
			nowTimetype(nv, ov) {
				this.search()
			},
			firstTime(){
				this.search()
			},
			secondTime(){
				this.search()
			},
			/* date1(nv, ov) {
				this.search()
			},
			date2(nv, ov) {
				this.search()
			}, */
			apptypeValue(nv, ov) {
				this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds', nv)
				let list = []
				if(!isempty(nv)) {
					nv.forEach(item => {
						this.apptypeGroups.forEach(item2 => {
							if(item == item2.id) {
								list.push(item2)
							}
						})
					})
				}
				this.nowApptypeGroups = list
			}
		},
		methods: {
			selectAll() {
				//全选 先判断是否有选中的，有选中就清空
				if(this.apptypeValue.length==1) {
					this.nowApptypeGroup = this.apptypeGroups
					let idList = []
					this.apptypeGroups.forEach(item => {
						idList.push(item.id)
					})
					this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds', idList)
					this.apptypeValue = idList
				}else{
					this.nowApptypeGroup =[]
					this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds', [])
					this.apptypeValue=[]
				}
			},
			clickChange(index) {
				this.nowIndex = index - 1
			},
			prevClick() {
				if(this.nowIndex == 1) {
					this.$message('当前为第一页');
					return
				}
				this.nowIndex -= 1
			},
			nextClick() {
				if(this.nowIndex == Math.ceil(this.mergeDataList.length / this.pageLen)) {
					this.$message('当前为最后一页');
					return
				}
				this.nowIndex += 1
			},
			autoSelectMethod(item, index) {
				if(this.nowVirtualDevice != undefined) {
					return this.nowVirtualDevice.id == item.id && this.nowVirtualDevice.type == item.type
				} else {
					return item.type == 'virtualDevice'
				}
			},
			search() {
				this.dataList = []
				this.$api.historyApi.searchVariableHistoryWithDateType(this.allVariableName.join(','), this.nowTimetype, this.firstTime,
					respon => {
						this.$set(this.dataList, 0, respon)
					})
				this.$api.historyApi.searchVariableHistoryWithDateType(this.allVariableName.join(','), this.nowTimetype, this.secondTime,
					respon => {
						this.$set(this.dataList, 1, respon)
					})
			},
			tranList(dataObject) {
				//取出数据中的有效数据组织为数组
				var list = []
				var keys = Object.keys(dataObject)
				for(var i = 0, len = keys.length; i < len; i++) {
					var key = keys[i]
					var dataList = dataObject[key]
					if(!isempty(dataList)) {
						switch(this.nowTimetype) {
							case 'day':
								//取出每个整点值
								list.push(this.tranDayList(key, dataList[0]))
								break
							case 'week':
								list.push(this.tranWeekList(key, dataList))
								break
							case 'month':
								list.push(this.tranMonthList(key, dataList[0]))
								break
							case 'quarter':
								list.push(this.tranQuarterList(key, dataList))
								break
							case 'year':
								list.push(this.tranYearList(key, dataList))
								break
						}
					}
				}
				return list
			},
			getAvg(data) {
				//计算出合理值
				if(!isnull(data.avg)) {
					return data.avg
				}
				if(!isempty(data.data)) {
					var count = 0
					var sum = data.data.reduce((a, b) => {
						if(isnull(b)) {
							return a
						}
						count++
						return a + b
					})
					if(count != 0) {
						return cutDigital(sum / count)
					}
				}
				return undefined
			},
			tranDayList(key, item) {
				//每天的数据，取整点值
				var name = this.from2name[key] ? this.from2name[key] : key
				var list = [name.subByFirstChar('.')]
				if(isempty(item.data)) {
					return list
				}
				for(var i = 0, len = item.data.length; i < len; i += 12) {
					var temp = item.data[i]
					if(isNaN(parseFloat((temp))) || isnull(parseFloat((temp)))) {
						temp = undefined
					}
					list.push(temp)
				}
				return list
			},
			tranWeekList(key, dataList) {
				//每周的数据，取平均值
				// var list = [key.subByFirstChar('.')]
				var name = this.from2name[key] ? this.from2name[key] : key
				var list = [name.subByFirstChar('.')]
				for(var i = 0; i < dataList.length; i++) {
					list.push(this.getAvg(dataList[i]))
				}
				return list
			},
			tranMonthList(key, item) {
				//每周的数据，取平均值
				// var list = [key.subByFirstChar('.')]
				var name = this.from2name[key] ? this.from2name[key] : key
				var list = [name.subByFirstChar('.')]
				if(!isempty(item.data)) {
					var res = item.data.map(i => {
						if(isNaN(parseFloat((i))) || isnull(parseFloat((i)))) {
							return undefined
						} else {
							return i
						}
					})
					list.addAll(res)
				}
				return list
			},
			tranQuarterList(key, dataList) {
				//每周的数据，取平均值
				var name = this.from2name[key] ? this.from2name[key] : key
				var list = [name.subByFirstChar('.')]
				for(var i = 0; i < dataList.length; i++) {
					list.push(this.getAvg(dataList[i]))
				}
				return list
			},
			tranYearList(key, dataList) {
				//每周的数据，取平均值
				var name = this.from2name[key] ? this.from2name[key] : key
				var list = [name.subByFirstChar('.')]
				for(var i = 0; i < dataList.length; i++) {
					list.push(this.getAvg(dataList[i]))
				}
				return list
			},
			reloadChart(list) {
				var selected = {}
				var legend = []
				var seriesList = []
				for(var i = 0, len = list.length; i < len; i++) {
					var item = list[i]
					var name = item.shift()
					seriesList.push({
						name: name,
						type: 'line',
						smooth: true,
						symbol: 'emptyCircle',
						markPoint: {
							data: [{
								name: '最大值',
								type: 'max'
							}]
						},
						sampling: 'average',
						data: item,
					})
					selected[name] = i < 12 ? true : false
					legend.push({
						name: name,
						icon: 'roundRect'
					})
				}
				this.options.series = seriesList
				this.options.legend.data = legend
				this.options.legend.selected = selected
				this.options.title.text = this.nowVirtualDevice.name + "-对标曲线"
				this.$refs.vchart.setData(this.options, true)
			},
			getQuarterList(date) {
				switch(date.getMonth() / 3 | 0) {
					case 0:
						return ['一月', '二月', '三月']
					case 1:
						return ['四月', '五月', '六月']
					case 2:
						return ['七月', '八月', '九月']
					case 3:
						return ['十月', '十一月', '十二月']
				}
			}
		}
	}
</script>

<style scoped>
	.pageBody {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	
	.timeTips {
		font-size: .14rem;
		margin-left: .1rem;
	}
	
	.timeBenchmarkBody {
		width: 100%;
		display: flex !important;
		align-items: center;
		justify-content: space-between;
	}
</style>
